import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

const QUERY = graphql(`
  query StripeAPIKeys($companyId: ID!) {
    stripeAPIKeys(companyId: $companyId) {
      id
      name
      secretKey
      publishableKey
      webhookSecret
    }
  }
`);

export default function useStripeApiKeys(companyId: string) {
  return useQuery(QUERY, {
    variables: { companyId },
  });
}
